var map = {
	"./PM_2.2.2.png": 40851,
	"./PM_2.3.2.png": 81711,
	"./PM_3.2.2.png": 46955,
	"components/Catalog/P/img/glass/pr/prPlusWhite/PM_2.2.2.png": 40851,
	"components/Catalog/P/img/glass/pr/prPlusWhite/PM_2.3.2.png": 81711,
	"components/Catalog/P/img/glass/pr/prPlusWhite/PM_3.2.2.png": 46955
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 16834;